export default {
  data: () => ({
    originatorTitles: {
      lma: 'LMA',
      post_closing: 'Post Closing',
      closer: 'Closer',
      funder: 'Funder',
      loan_account_coordinator: 'Loan Account Coordinator',
      bpc: 'BPC',
    },
    seniorFunderTitles: {
      funder: 'Funder',
    },
  }),
};
